"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../assets/constants/constants");
const users_1 = require("../../utils/users");
const helpers_1 = require("../../utils/helpers");
const beds_1 = require("../../utils/beds");
// TODO: [XP360-669] Refatorar o arquivo, transformar de função para classe.
const BookingRequestBuilder = {
    getBookingRequest: ({ bookId, formValues, confirmValues, bookingSaved, key, }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const userEmail = (0, users_1.getUserData)().email;
        const [firstName, lastName] = (0, helpers_1.splitFullName)(formValues.suites[key].fullnameRequired);
        const tmpGuests = formValues.suites[key].guests
            .filter(guest => guest.fullname)
            .map(guest => {
            const birtDayGuest0 = (0, moment_1.default)(guest.birthday, constants_1.DEFAULT_FORMAT_DATE_PT_BR);
            return {
                doc: (0, helpers_1.myTrim)(guest.rg),
                email: (0, helpers_1.myTrim)(guest.email),
                name: (0, helpers_1.myTrim)(guest.fullname),
                ddi: (0, helpers_1.myTrim)(guest.ddi),
                phone: (0, helpers_1.myTrim)(guest.phone).replace(`${(0, helpers_1.myTrim)(guest.ddi)}#`, ''),
                birthday: birtDayGuest0.isValid() ? birtDayGuest0.format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL) : '',
                docType: (0, helpers_1.myTrim)(guest.documentTypeGuest),
            };
        });
        const parkingVehicle = `${((_a = formValues.suites[key].vehicleBrand) === null || _a === void 0 ? void 0 : _a.trim()) || ''}-${((_b = formValues.suites[key].vehicleColor) === null || _b === void 0 ? void 0 : _b.trim()) || ''}|${((_c = formValues.suites[key].vehiclePlate) === null || _c === void 0 ? void 0 : _c.trim()) || ''}|${((_d = formValues.suites[key].vehicleBrand) === null || _d === void 0 ? void 0 : _d.trim()) ? confirmValues.firstNight : ''}|${((_e = formValues.suites[key].vehicleBrand) === null || _e === void 0 ? void 0 : _e.trim())
            ? (0, moment_1.default)(confirmValues.lastNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
            : ''}`;
        const [guests, ...visitors] = tmpGuests;
        const infoPreCheckIn = {
            name: (0, helpers_1.myTrim)(formValues.suites[key].fullnameRequired),
            docType: (0, helpers_1.myTrim)(formValues.suites[key].documentTypeGuestRequired),
            doc: (0, helpers_1.myTrim)(formValues.suites[key].rgRequired),
            birthday: (0, moment_1.default)(formValues.suites[key].birthdayRequired, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL),
            ddi: (0, helpers_1.myTrim)(formValues.suites[key].ddiRequired),
            phone: (0, helpers_1.myTrim)(formValues.suites[key].phoneRequired).replace(`${(0, helpers_1.myTrim)(formValues.suites[key].ddiRequired)}#`, ''),
            email: (0, helpers_1.myTrim)(userEmail),
            address: {
                zip: formValues.suites[key].addressCep,
                // os campos de endereço estão separados por \n no fim, então não tirem o ENTER dessa propriedade "fullAddress"
                fullAddress: `${(0, helpers_1.myTrim)(formValues.suites[key].addressName)}
        ${formValues.suites[key].addressNumber}
        ${(0, helpers_1.myTrim)(formValues.suites[key].addressComplement)}
        ${(0, helpers_1.myTrim)(formValues.suites[key].addressDistrict)}`,
                state: formValues.suites[key].addressState,
                city: (0, helpers_1.myTrim)(formValues.suites[key].addressCity),
                country: 'Brazil',
            },
            guests: guests ? [guests] : [],
            visitors,
            hostingWork: formValues.suites[key].hostingWork,
            hostingPurchases: formValues.suites[key].hostingPurchases,
            hostingPrivacy: formValues.suites[key].hostingPrivacy,
            hostingTourism: formValues.suites[key].hostingTourism,
            vehicles: [
                {
                    model: `${((_f = formValues.suites[key].vehicleBrand) === null || _f === void 0 ? void 0 : _f.trim()) || ''} ${((_g = formValues.suites[key].vehicleColor) === null || _g === void 0 ? void 0 : _g.trim()) || ''}`,
                    plate: `${((_h = formValues.suites[key].vehiclePlate) === null || _h === void 0 ? void 0 : _h.trim()) || ''}`,
                    usedFrom: `${((_j = formValues.suites[key].vehicleBrand) === null || _j === void 0 ? void 0 : _j.trim())
                        ? (0, moment_1.default)(confirmValues.firstNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
                        : ''}`,
                    usedTo: `${((_k = formValues.suites[key].vehicleBrand) === null || _k === void 0 ? void 0 : _k.trim())
                        ? (0, moment_1.default)(confirmValues.lastNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
                        : ''}`,
                },
            ],
        };
        const priceRoom = Number(confirmValues.suitePrice.replace('.', '').replace(',', '.'));
        const invoice = [
            Object.assign({ description: `PagSeguro - Quarto ${confirmValues.suite.roomId} Entrada: ${confirmValues.firstNight} Saída: ${confirmValues.lastNight}`, price: priceRoom }, constants_1.DEFAULT_VALUES_BEDS24_INVOICE),
            Object.assign({ description: `Limpeza ${confirmValues.cleaningFee} per room one time`, price: constants_1.DEFAULT_CLEANING_FEE }, constants_1.DEFAULT_VALUES_BEDS24_INVOICE),
        ];
        let newTotalPrice = confirmValues.totalPrice;
        if (confirmValues.refundPrice) {
            newTotalPrice += confirmValues.refundPrice;
        }
        let infoItems = [];
        if (!bookingSaved) {
            infoItems = [
                {
                    code: constants_1.DEFAULT_MSG_BEDS24_INFO_ITEMS.CODE,
                    text: constants_1.DEFAULT_MSG_BEDS24_INFO_ITEMS.TEXT,
                },
            ];
        }
        // Pega o primeiro hóspede adicional válido que foi preenchido para usar como guest2
        let guest2 = formValues.suites[key].guests.find(guest => guest.fullname);
        // caso não encontre nenhum hóspede adicional válido é criado um guest2 com undefined nos dados
        if (!guest2) {
            guest2 = {
                fullname: '',
                rg: '',
                email: '',
                ddi: '',
                birthday: '',
                documentTypeGuest: '',
                phone: '',
            };
        }
        const guestDocs = formValues.suites[key].guests
            .map(guest => Boolean(guest.fullname))
            .map((guest, index) => {
            if (guest) {
                return [
                    formValues.suites[key].guests[index].fullname,
                    formValues.suites[key].guests[index].rg,
                    formValues.suites[key].guests[index].email,
                ].join('|');
            }
        });
        const response = Object.assign(Object.assign({ userEmail: (0, helpers_1.myTrim)(userEmail), bookId, roomId: confirmValues.suite.roomId, roomQty: confirmValues.suiteQtyString, status: constants_1.STATUS_REQUEST_BEDS24, firstNight: confirmValues.firstNight, lastNight: confirmValues.lastNight, numAdult: confirmValues.guestsQtyString, numChild: constants_1.DEFAULT_NUMCHILD_BEDS24, guestFirstName: (0, helpers_1.myTrim)(firstName), guestName: (0, helpers_1.myTrim)(lastName), guestEmail: (0, helpers_1.myTrim)(userEmail), guestPhone: (0, helpers_1.myTrim)(formValues.suites[key].phoneRequired), guestAddress: `${formValues.suites[key].addressName}, ${formValues.suites[key].addressNumber}, ${(0, helpers_1.myTrim)(formValues.suites[key].addressComplement)}, ${(0, helpers_1.myTrim)(formValues.suites[key].addressDistrict)}, ${(0, helpers_1.myTrim)(formValues.suites[key].addressCep)}`, guestCity: (0, helpers_1.myTrim)(formValues.suites[key].addressCity), guestState: (0, helpers_1.myTrim)(formValues.suites[key].addressState), guestCountry: 'Brazil', guestDoc: (0, helpers_1.myTrim)(formValues.suites[key].rgRequired), guest2Name: guestDocs.filter(guest => guest).join('; '), guestBirthDate: (0, moment_1.default)(formValues.suites[key].birthdayRequired, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_PT_BR), guest2Doc: `Check-in: ${formValues.suites[key].checkInTime} | Check-out: ${formValues.suites[key].checkOutTime}`, guest2Annotations: '', infoPreCheckIn: JSON.stringify(infoPreCheckIn), infoPreCheckInBeds: (0, beds_1.formatInfoPreCheckInBeds)(JSON.stringify(infoPreCheckIn)), price: newTotalPrice }, constants_1.DEFAULT_VALUES_BEDS24_BOOKING), { notifyUrl: true, notifyGuest: false, notifyHost: false, assignBooking: false, checkAvailability: true, deleteInvoice: true, invoice,
            infoItems,
            parkingVehicle, hostingTourism: formValues.suites[key].hostingTourism || false, hostingPrivacy: formValues.suites[key].hostingPrivacy || false, hostingPurchases: formValues.suites[key].hostingPurchases || false, hostingWork: formValues.suites[key].hostingWork || false, verifyInformation: formValues.suites[key].verifyInformation });
        return response;
    },
    hubspotFormBuilder: ({ formValues, key, pageUri, pageName, guestsQty, paymentMethod, confirmValues, }) => {
        var _a, _b;
        // Pega o primeiro hóspede adicional válido que foi preenchido para usar como guest2
        let guest2 = formValues.suites[key].guests.find(guest => guest.fullname);
        // caso não encontre nenhum hóspede adicional válido é criado um guest2 com undefined nos dados
        if (!guest2) {
            guest2 = {
                fullname: '',
                documentGuest: '',
                email: '',
                ddi: '',
                birthday: undefined,
                documentTypeGuest: '',
                phone: '',
            };
        }
        const bookId = (0, helpers_1.decrypty)(localStorage.getItem('XP360:beds_bookId'));
        const paymentsMethod = {
            ONLINE_DEBIT: 'Débito',
            PIX: 'PIX',
        };
        const splitedFullName = (0, helpers_1.myTrim)(formValues.suites[key].fullnameRequired).split(' ');
        const firstName = splitedFullName.splice(0, 1)[0];
        const lastname = splitedFullName.join(' ');
        const bookingReason = ['hostingPrivacy', 'hostingTourism', 'hostingPurchases', 'hostingWork'].filter(reason => formValues.suites[key][reason])[0] || '';
        const reasonsHash = {
            hostingPrivacy: 'Namorar',
            hostingWork: 'Trabalhar',
            hostingPurchases: 'Comprar',
            hostingTourism: 'Turistar',
        };
        const adresss = `${(0, helpers_1.myTrim)(formValues.suites[key].addressName)} ${formValues.suites[key].addressNumber}
    ${(0, helpers_1.myTrim)(formValues.suites[key].addressComplement)}`;
        const guestList = ['segundo', 'terceiro', 'quarto', 'quinto'];
        const guestHubs = guestList.map((position, idx) => {
            var _a;
            const guest = formValues.suites[key].guests[idx];
            return [
                {
                    name: `nome_${position}_hospede`,
                    value: (0, helpers_1.myTrim)((guest === null || guest === void 0 ? void 0 : guest.fullname) || ' '),
                },
                {
                    name: `documento_${position}_hospede`,
                    value: (0, helpers_1.myTrim)((guest === null || guest === void 0 ? void 0 : guest.documentGuest) || ' '),
                },
                {
                    name: `data_de_nascimento_${position}${idx > 0 ? '_hospede' : ''}`,
                    value: (guest === null || guest === void 0 ? void 0 : guest.birthday)
                        ? (0, moment_1.default)(guest === null || guest === void 0 ? void 0 : guest.birthday, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
                        : ' ',
                },
                {
                    name: `e_mail_${position}_hospede`,
                    value: (0, helpers_1.myTrim)((guest === null || guest === void 0 ? void 0 : guest.email) || ' '),
                },
                {
                    name: `celular_${position}_hospede`,
                    value: `${(guest === null || guest === void 0 ? void 0 : guest.phone) ? `${guest === null || guest === void 0 ? void 0 : guest.ddi}${(_a = guest === null || guest === void 0 ? void 0 : guest.phone) === null || _a === void 0 ? void 0 : _a.replace(/\D/g, '')}` : ''}`,
                },
            ];
        });
        const userEmail = (0, users_1.getUserData)().email;
        const infoHubspot = {
            fields: [
                { name: 'email', value: (0, helpers_1.myTrim)(userEmail) },
                { name: 'firstname', value: firstName },
                { name: 'lastname', value: lastname },
                { name: 'documento', value: (0, helpers_1.myTrim)(formValues.suites[key].documentGuestRequired) },
                {
                    name: 'address',
                    value: (0, helpers_1.myTrim)(adresss.replace(/\n/, '')),
                },
                { name: 'city', value: (0, helpers_1.myTrim)(formValues.suites[key].addressCity) },
                { name: 'state', value: formValues.suites[key].addressState },
                { name: 'country', value: (0, helpers_1.myTrim)(formValues.suites[key].country) || 'Brazil' },
                { name: 'zip', value: formValues.suites[key].addressCep },
                {
                    name: 'mobilephone',
                    value: `${(0, helpers_1.myTrim)(formValues.suites[key].ddiRequired)}${(0, helpers_1.myTrim)(formValues.suites[key].phoneRequired.replace(/\D/g, ''))}`,
                },
                {
                    name: 'data_de_nascimento',
                    value: (0, moment_1.default)(formValues.suites[key].birthdayRequired, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL),
                },
                { name: 'quantidade_de_hospedes', value: guestsQty },
                { name: 'data_da_reserva', value: (0, moment_1.default)(new Date()).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL) },
                { name: 'noites_vendidas', value: parseInt(confirmValues.dailyQtyString, 10) },
                { name: 'valor_da_venda', value: confirmValues.originalTotalPrice },
                { name: 'categoria', value: (_a = confirmValues.suite) === null || _a === void 0 ? void 0 : _a.suiteTitle },
                { name: 'propriedade', value: (_b = confirmValues.suite) === null || _b === void 0 ? void 0 : _b.buildingName },
                { name: 'forma_de_pagamento', value: paymentsMethod[paymentMethod] || 'Crédito' },
                { name: 'codigo_da_reserva', value: bookId },
                { name: 'canal_de_origem', value: 'site360suites' },
                { name: 'check_in', value: confirmValues.firstNight },
                { name: 'check_out', value: confirmValues.lastNight },
                { name: 'consentimento_e_mail', value: formValues.acceptOffers ? 'Sim' : 'Não' },
                { name: 'interesse', value: reasonsHash[bookingReason] || '' },
            ],
            context: {
                pageName,
                pageUri,
                hutk: '',
            },
        };
        infoHubspot.fields = [...infoHubspot.fields, ...guestHubs.flatMap(el => el)];
        return infoHubspot;
    },
};
exports.default = BookingRequestBuilder;
